import { render, staticRenderFns } from "./ConfigSelectCommunityModal.vue?vue&type=template&id=cff6e602&scoped=true"
import script from "./ConfigSelectCommunityModal.vue?vue&type=script&lang=js"
export * from "./ConfigSelectCommunityModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigSelectCommunityModal.vue?vue&type=style&index=0&id=cff6e602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff6e602",
  null
  
)

export default component.exports